require('./brokerStocksContractStep3RightCol.scss');
const { SECOND_STEP } = require('constants/index');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');

// @ components
const OKInformativeList = require('components/rebrand/OKInformativeList/OKInformativeList');
const OKInformativeListItem = require('components/rebrand/OKInformativeListItem/OKInformativeListItem');

// @ helpers
const { formatText } = require('core/i18n').i18n;
const { formatCurrency, formatAmount } = require('utilities/currencyHelper');

class BrokerStocksContractStep3RightCol extends React.Component {
    constructor() {
        super();
        this.buildInterveners = this.buildInterveners.bind(this);
    }

    buildInterveners(rows) {
        return rows.map((row, index) => {
            return (
                <OKInformativeListItem
                    key={index}
                    title={row.get('type')}
                    bodyText={row.get('name')}
                    className="broker-stock-contract-step3-right-col__informative-list-item"
                    bodyWordBreak={false}
                />
            );
        });
    }

    render() {
        const { immAccount, immStocksContractForm } = this.props;
        //TODO : rename keys from Step2 to Step3 
        const accountSubTitle = formatText('broker-stockContractStep2CCAssociated');
        const ownerSelectedBalanceLabel = formatText('broker-stockContractStep2Balance');
        const intervenersLabel = formatText('broker-stockContractStep2Interveners');

        const alias = immAccount.get('accountType');
        const iban = immAccount.get('iban');
        const balanceCurrency = immAccount.get('balance').get('currency');
        const balanceAmount = immAccount.get('balance').get('amount');
        const ownerSelectedBalanceText =
            formatAmount(balanceAmount) + ' ' + formatCurrency(balanceCurrency);
        const intervenersRows = immStocksContractForm.getIn(['steps', SECOND_STEP, 'interveners']);
        const intervenerListBlock = this.buildInterveners(intervenersRows);

        return (
            <div className="broker-stock-contract-step3-right-col">
                <h3 className="broker-stock-contract-step3-right-col__subtitle">
                    {accountSubTitle}
                </h3>
                <div className="broker-stock-contract-step3-right-col__account">
                    <h4 className="broker-stock-contract-step3-right-col__account-label">
                        {alias}
                    </h4>
                    <p>
                        {iban}
                    </p>
                </div>
                <div className="broker-stock-contract-step3-right-col__owner">
                    <span className="broker-stock-contract-step3-right-col__owner-balance no-print-out">
                        {ownerSelectedBalanceLabel} {ownerSelectedBalanceText}
                    </span>
                </div>
                <div className="broker-stock-contract-step3-right-col__interveners">
                    <h4 className="broker-stock-contract-step3-right-col__interveners-label">
                        {intervenersLabel}
                    </h4>
                    <OKInformativeList>
                        {intervenerListBlock}
                    </OKInformativeList>
                </div>
            </div>
        );
    }
}

BrokerStocksContractStep3RightCol.propTypes = {
    immAccount: PropTypes.object,
    immStocksContractForm: PropTypes.object
};

module.exports = BrokerStocksContractStep3RightCol;